import { AlertTriangle } from 'lucide-react';
import styled from 'styled-components';

export const WarningBannerBox = styled.div.attrs({
  className: 'flex items-start justify-between gap-4 bg-amber-100 px-4 py-3 text-amber-900',
})``;

export const WarningBannerContent = styled.div.attrs({
  className: 'flex items-start gap-3 min-w-0',
})``;

export const WarningBannerIcon = styled(AlertTriangle).attrs({
  className: 'size-5 shrink-0 mt-0.5',
  'aria-hidden': true,
})``;

export const WarningBannerTextBlock = styled.div.attrs({
  className: 'min-w-0',
})``;

export const WarningBannerTitle = styled.p.attrs({
  className: 'text-sm font-medium',
})``;

export const WarningBannerDescription = styled.p.attrs({
  className: 'text-sm',
})``;
